import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { ProjectsComponent, ProjectdetailsComponent, SprintComponent, } from './';
import { WorkMainComponent } from './components/work-main.component';

import { AuthGuardService } from '../../shared/services/auth-guard.service';

import { WorkConstants } from './work.const';

// Route Configuration
export const workRoutes: Routes = [
    {
        path: 'works',
        component: WorkMainComponent,
        children: [
            {
                path: 'projects',
                component: ProjectsComponent,
                data: { subHeader: WorkConstants.routeDataProjects },
                canActivate: [AuthGuardService]
            },
            {
                path: WorkConstants.basicConstans.routeProjects + "/:projectId/" + WorkConstants.routeSprint + "/:id",
                component: SprintComponent,
                data: { subHeader: WorkConstants.routeDataProjects },
                canActivate: [AuthGuardService]
            },
            {
                path: WorkConstants.linkProjectDetails + "/:id",
                component: ProjectdetailsComponent,
                data: { subHeader: WorkConstants.routeDataProjects },
                canActivate: [AuthGuardService]
            }    
        ]
    }
];

export const workRoutingProviders: any[] = [AuthGuardService];


// WEBPACK FOOTER //
// ./src/app/modules/work/work.routes.ts